var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFahrerhausschalter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.2474,
    strokeLinecap: "round",
    d: "M19.018,37.74 c0,3.957-3.164,7.164-7.062,7.164c-3.899,0-7.059-3.207-7.059-7.164c0-3.961,3.16-7.168,7.059-7.168 C15.854,30.572,19.018,33.779,19.018,37.74z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.1332,
    points: "2.085,29.619 34.584,29.619 34.584,3.095 1.983,3.095  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.1332,
    x1: 26.783,
    y1: 44.686,
    x2: 33.479,
    y2: 44.686
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.1332,
    x1: 30.076,
    y1: 44.635,
    x2: 30.076,
    y2: 29.568
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.795,31.139 43.107,33.482 46.018,9.252 34.686,30.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.1741,
    points: "35.795,31.139 43.107,33.482 46.018,9.252 34.686,30.549  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFahrerhausschalter);
export default __webpack_public_path__ + "static/media/Fahrerhausschalter.a953fc4e92a06991bec40df8785bfb6a.svg";
export { ForwardRef as ReactComponent };